import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unique'
})
export class UniquePipe implements PipeTransform {

  transform(value: any[], key: string): any[] {
    if (!Array.isArray(value)) {
      return value;
    }

    return value.filter((item, index, self) => 
      index === self.findIndex((t) => (
        t[key] === item[key]
      ))
    );
  }

}
